

































































































































import Vue from "vue";
import Component from "vue-class-component";
import Article from "@/model/article";
import Image from "@/model/image";
import qSlider from "@/common/qSlide.vue";
import { formatImageUrl } from "@/common/utils";
import { namespace } from "vuex-class";
import { BlogManagerArticleService } from "@/common/api/services/BlogManagerArticleService";

const auth = namespace("Auth");

@Component({
  name: "BlogPreview",
  components: {
    qSlider,
  },
})
export default class BlogPreview extends Vue {
  @auth.Getter
  getUsingGroup!: number;
  @auth.Getter
  getUsingGroupName!: string;

  public article: Article = new Article();
  public groupImage: Image = new Image();
  public imageUrl = "";
  public errors: any = {};
  public errorStyle = {
    maxWidth: "100%",
  };

  async mounted() {
    let blog_preview_data = localStorage.getItem("blog_preview_data");
    this.article = new Article(JSON.parse(blog_preview_data));
    (this.$refs.qSlider as qSlider).init();

    await this.findGroupImage();
  }

  public async findGroupImage() {
    const result = await BlogManagerArticleService.groupAdminArticlePreview({
      groupId: this.getUsingGroup,
    });
    this.groupImage = new Image(result.data.image);
    this.imageUrl = this.formatUrl(this.groupImage.name);
  }

  formatUrl(fileName) {
    return formatImageUrl(fileName, "1600x960", "contain");
  }
}
